<!-- Vertical layout -->
<ng-scrollbar style="height: calc(100vh - 70px)" visibility="hover">
  <div class="navbar-content">
    <ul class="nav coded-inner-navbar" (click)="fireOutClick()" (keydown.space)="fireOutClick()" (keydown.enter)="fireOutClick()">
      @for (item of navigations; track item.id) {
        @if (item.type === 'group') {
          <app-nav-group [item]="item" />
        } @else if (item.type === 'collapse') {
          <app-nav-collapse [item]="item" />
        } @else if (item.type === 'item') {
          <app-nav-item [item]="item" />
        }
      }
    </ul>
    <div class="version">
      <label for="version" disabled class="pe-auto">v{{ currentApplicationVersion }}</label>
    </div>
  </div>
</ng-scrollbar>
